import CustomToast from "./custom-toast";
import { ReactNode } from "react";

export enum VariantType {
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info",
  WARNING = "warning"
}

export type IShowToast = (message: string, variant: VariantType) => void;

export default function usePopupSnackbar() {
  const { success, error, warning, info } = CustomToast();
  const showToast = (
    message: string,
    variant: VariantType,
    action?: ReactNode,
    icon?: ReactNode,
    progress?: boolean,
    description?: string
  ) => {
    switch (variant) {
      case VariantType.SUCCESS:
        success({
          title: message,
          description: description || "",
          action: action || null,
          icon: icon || null,
          progress: progress || false
        });
        break;
      case VariantType.ERROR:
        error({
          title: message,
          description: description || "",
          action: action || null,
          icon: icon || null,
          progress: progress || false
        });
        break;
      case VariantType.INFO:
        info({
          title: message,
          description: description || "",
          action: action || null,
          icon: icon || null,
          progress: progress || false
        });
        break;
      case VariantType.WARNING:
        warning({
          title: message,
          description: description || "",
          action: action || null,
          icon: icon || null,
          progress: progress || false
        });
        break;
    }
  };

  return { showToast };
}
